import { React, PropTypes, reduxConnect, styled, useTheme } from '../lib/imports';

import { SectionTitle, Spacing, Text } from '../components';
import CurrentCard from './CurrentCard';
import NoChallengeCard from './NoChallengeCard';
import { useCdnImage, getAssetSet } from '../app/context/config';
import { useSelector } from 'react-redux';

const assetSet = (filename) => getAssetSet(useCdnImage, filename);

const ChallengesContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.sectionBg};
`;

export const ChallengeDisclaimer = styled(Text)`
  flex: 1;
  color: ${({ theme }) => theme.colors.white};
  margin-top: ${({ theme }) => theme.spacings.giga};
`;

const Challenges = ({
  title,
  blurb,
  playoffBlurb,
  blurb2,
  language,
  disclaimer,
  seasonPrizes,
  seasonText,
  seasonTitle,
  monthlyChallengeTitle,
  monthlyPrizes,
  monthlyText,
}) => {
  const theme = useTheme();
  const { leaderboard } = useSelector((state) => state);
  const { isCurrentlyPlayoffs, isCurrentlySeason } = leaderboard;

  const seasonCardProps = {
    title: seasonTitle,
    logosSrc: [{ src: `2027_Season_Prize_new.png`, width: '100%' }],
    challengeDisclaimer: <ChallengeDisclaimer>{disclaimer}</ChallengeDisclaimer>,
    background: `${theme.colors.darkBg} no-repeat top / 100% 266px url(${assetSet('challengeCardBackground')})`,
    sponsorText: seasonText,
    prizes: seasonPrizes,
    noPadding: true,
  };

  const monthlyCardProps = {
    title: monthlyChallengeTitle,
    logosSrc: [{ src: `2027_monthly_prizes_${language}.png`, width: '100%' }],
    background: `${theme.colors.darkBg} no-repeat top / 100% 163px url( ${assetSet('challengeCardHeader')})`,
    challengeDisclaimer: <ChallengeDisclaimer>{disclaimer}</ChallengeDisclaimer>,
    prizes: monthlyPrizes,
    spacingTop: true,
    hasDivider: true,
  };

  return (
    <ChallengesContainer>
      <Spacing>
        <SectionTitle text={title} size='deca' shadow />
      </Spacing>
      <Spacing sizeLeft='peta' sizeRight='peta' sizeTop='giga'>
        <Text centered size='tera' noMargin>
          {isCurrentlyPlayoffs ? playoffBlurb : blurb}
        </Text>
        <Spacing sizeTop='giga' />
        <Text centered size='tera' noMargin>
          {blurb2}
        </Text>
      </Spacing>

      {isCurrentlySeason && (
        <Spacing sizeLeft='mega' sizeRight='mega'>
          <Spacing sizeTop='mega' paddingBottom='giga'>
            <CurrentCard {...seasonCardProps} active={isCurrentlySeason} />
          </Spacing>
          <Spacing sizeTop='mega' paddingBottom='giga'>
            <CurrentCard {...monthlyCardProps} sponsorText={monthlyText} active={isCurrentlySeason} />
          </Spacing>
        </Spacing>
      )}
      {!isCurrentlySeason && !isCurrentlyPlayoffs && (
        <Spacing sizeLeft='mega' sizeRight='mega'>
          <Spacing sizeTop='mega' paddingBottom='giga'>
            <NoChallengeCard />
          </Spacing>
        </Spacing>
      )}
    </ChallengesContainer>
  );
};

Challenges.propTypes = {
  title: PropTypes.string,
  blurb: PropTypes.string,
  blurb2: PropTypes.string,
  challenge1Src: PropTypes.string,
};

const mapStateToProps = (state) => {
  const { strings, config } = state;
  const { language } = config;

  const allStrings = {
    title: strings['titles/section/challenges/text'],
    blurb: strings['challenges/blurb/text/line/1'],
    playoffBlurb: strings['challenges/blurb/text/line/playoffs'],
    blurb2: strings['challenges/blurb/text/line/2'],
    dates: strings['challenges/dates'],
    pasts: strings['challenges/pasts'],
    disclaimer: strings['challenges/footer/disclaimer'],
    monthlyChallengeTitle: strings['challenges/monthly/title'],
    monthlyPrizes: strings['challenges/prizes'],
    seasonTitle: strings['challenges/season/title'],
    seasonText: strings['challenges/season/text'],
    seasonPrizes: strings['challenges/season/prizes'],
    monthlyText: strings['challenges/text'],
  };

  return {
    ...allStrings,
    language,
  };
};

export default reduxConnect(mapStateToProps)(Challenges);
